const untrailingslashit = str => str.endsWith("/") || str.endsWith("\\") ? untrailingslashit(str.slice(0, -1)) : str;
const trailingslashit = str => `${untrailingslashit(str)}/`;

// Allows to make an interface extension and make some properties optional (https://git.io/JeK6J)

export { untrailingslashit, trailingslashit };